import { Component, input, output } from '@angular/core';
import { UserAddress } from 'app/core/models/user.model';
import { AddressUtil } from 'app/core/utils/address.utils';

@Component({
  selector: 'app-address-selector',
  templateUrl: './address-selector.component.html',
  host: {
    class: 'flex justify-between items-center min-h-12',
  },
})
export class AddressSelectorComponent {
  addresses = input<UserAddress[]>([]);
  selectedAddressId = input<string>();
  currentAddressText = input<string>('Endereço');

  addressSelected = output<UserAddress>();

  isSelectedAddress(addressId: string): boolean {
    return this.selectedAddressId() === addressId;
  }

  selectAddress(address: UserAddress): void {
    this.addressSelected.emit(address);
  }

  getFormattedAddress(address: UserAddress): string {
    return AddressUtil.getFormattedAddress(address);
  }
}
